import { Button, Grid2, MenuItem, Select, Snackbar, TextField, Typography } from "@mui/material";
import Navbar from "../navbar/Navbar";
import Sidemenu from "../sidemenu/Sidemenu";
import { useEffect, useState } from "react";
import { Label } from "flowbite-react";
import {makeGetRequestToUrl} from '../commonFunc.jsx';
import {makePostRequestToUrl} from '../commonFunc.jsx';
import config from '../../config/config.js';
import { useNavigate } from "react-router-dom";
import TokenError from "../tokenError";
var constants = require('../../constant');

const ScheduleRideSettings = () =>{
    const [isActive, setIsActive] = useState(true);
    const [scheduleAlarmTime, setScheduleAlarmTime] = useState('');
    const [scheduleCurrTimeDiff, setScheduleCurrTimeDiff] = useState('');
    const [scheduleDaysLimit, setScheduleDaysLimit] = useState('');
    const [scheduleRidesLimit, setScheduleRidesLimit] = useState('');
    const [scheduleCancelWindow, setScheduleCancelWindow] = useState('');
    const [dispatchType, setDispatchType] = useState('');
    const [delayedTimeThreshold, setDelayedTimeThreshold] = useState('');

    const serverUrl = config.serverUrl;
    const operationsUrl = config.operationsUrl;
    const [message, setMessage] = useState('');
    const [snackbar, showSnackbar] = useState(false);
    const [dataa, setDataa] = useState([]);
    const [scheduleId, setScheduleId] = useState(0);
    const [tokenExpired, setTokenExpired] = useState(false);
    const [errorMessage, setErrorMessage] = useState('');
    const navigate = useNavigate();

    const fetchScheduleRideSettings = async() => {
        try {
            const token = localStorage.getItem('token');
            const url = serverUrl + '/settings/schedule_ride';
            const timestamp = new Date().getTime();
            const body = {
                token: token,
                timestamp: timestamp
            };
            const response =  await makeGetRequestToUrl(url, body);
            if(response.flag==200){
                // setDataa(response.data);
                const fetchedData = response.data[0];
                setScheduleAlarmTime(fetchedData.alarm_time);
                setScheduleCurrTimeDiff(fetchedData.current_time_diff);
                setScheduleDaysLimit(fetchedData.days_limit);
                setScheduleRidesLimit(fetchedData.rides_limit);
                setScheduleCancelWindow(fetchedData.cancel_window);
                setDispatchType(fetchedData.dispatch_type);
                setScheduleId(fetchedData.id);
                setDelayedTimeThreshold(fetchedData.delayed_time_threshold);
                setIsActive(fetchedData.is_active==0 ? false : true)
            }
            if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
        } 
        catch (error) {
            console.log('error', error);
        }
    }

    useEffect(()=> {
        fetchScheduleRideSettings();
    },[])

    const saveData = async() =>{
        const token = localStorage.getItem('token');
        const payload = {
            token: token,
            alarm_time: scheduleAlarmTime,
            cancel_window: scheduleCancelWindow,
            current_time_diff: scheduleCurrTimeDiff,
            days_limit: scheduleDaysLimit,
            dispatch_type: dispatchType,
            rides_limit: scheduleRidesLimit,
            is_active: isActive==true ? 1 : 0
        };
        if(scheduleId!=0){
            payload.id = scheduleId;
        }
        if(delayedTimeThreshold && dispatchType!=1){
            payload.delayed_time_threshold = delayedTimeThreshold;
        }

        try {
            const url = operationsUrl + '/schedule/add_update_schedule_ride_setting';
            const response = await makePostRequestToUrl(url,payload);
            if (response.flag === 200) {
                setMessage(response.message)
                showSnackbar(true);

            }
            else if(response.flag==102){
                console.log('Token is expired. Please login again')
                localStorage.removeItem('token');
                setErrorMessage('Your session has expired. Please log in again.');
                setTokenExpired(true);

                setTimeout(() => {
                    navigate('/signup');
                }, 2000);
                // navigate('/signup');
            }
            else {
                setMessage(response.message)
                showSnackbar(true);
            }

        } catch (error) {
            console.error('Error while saving document:', error);
            setMessage(error);
        }
    }

    const handleSnackbarClose = (event, reason) => {
        if (reason === 'clickaway') {
            return; 
        }
        showSnackbar(false); 
    };

    return(
        <div> 
            {tokenExpired && (<TokenError/>)}
            {/* <Navbar/>
            <div className='App'>
                <Sidemenu/>
                <div className='content'> */}
                    <Typography style={{ fontSize: '28px', fontWeight: '500' }}>Setting</Typography>

                    <Grid2 sx={{margin:"4px", backgroundColor:"#fff", borderRadius:'8px', padding:'12px', marginTop:'12px'}}>
                        <Typography sx={{color:'#4E545D', fontSize:'24px'}}>Schedule Ride Setting</Typography>
                        <Grid2 container item sx={{border:'1px solid #D1D5DB', marginTop:'18px', borderRadius:'12px', padding:'6px 12px', alignItems:'center'}}>
                            <Grid2 item ><Typography>Schedule Ride</Typography></Grid2>
                            <Grid2 item sx={{marginLeft:'auto'}}>
                                <Button
                                    variant="contained" onClick={() => setIsActive(true)} 
                                    style={{ backgroundColor: isActive ? '#0DBA78' : '#F4F4F4', color: isActive ? '#FFFFFF' : '#9E9E9E',textTransform: 'none',
                                        borderRadius: '8px 0 0 8px',boxShadow: 'none',padding: '6px 16px',minWidth: '80px'}}>
                                    Enable
                                </Button>
                                <Button
                                    variant="contained" onClick={() => setIsActive(false)} 
                                    style={{backgroundColor: !isActive ? '#D14545' : '#F4F4F4',color: !isActive ? '#FFFFFF' : '#9E9E9E',
                                        textTransform: 'none',borderRadius: '0 8px 8px 0',boxShadow: 'none',padding: '6px 16px', minWidth: '80px',
                                    }}>
                                    Disable
                                </Button>
                            </Grid2>
                        </Grid2>

                        <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                            <Grid2 item size={6}>
                                <Label>Schedule Alarm Time (in minutes)<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Alarm Time" fullWidth variant="outlined" type="text" 
                                    value={scheduleAlarmTime}
                                    onChange={(e) => setScheduleAlarmTime(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>

                            <Grid2 item size={6}>
                                <Label>Schedule Current Time Diff (in minutes)<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Current Time Diff" fullWidth variant="outlined" type="text" 
                                    value={scheduleCurrTimeDiff}
                                    onChange={(e) => setScheduleCurrTimeDiff(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>
                        </Grid2>

                        <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                            <Grid2 item size={6}>
                                <Label>Schedule Days Limit<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Days Limit" fullWidth variant="outlined" type="text" 
                                    value={scheduleDaysLimit}
                                    onChange={(e) => setScheduleDaysLimit(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>

                            <Grid2 item size={6}>
                                <Label>Schedule Rides Limit<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Rides Limit" fullWidth variant="outlined" type="text" 
                                    value={scheduleRidesLimit}
                                    onChange={(e) => setScheduleRidesLimit(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>
                        </Grid2>

                        <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                            <Grid2 item size={6}>
                                <Label>Schedule Cancel Window (in minutes)<span style={{ color: 'red' }}>*</span></Label>
                                <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Schedule Cancel Window" fullWidth variant="outlined" type="text" 
                                    value={scheduleCancelWindow}
                                    onChange={(e) => setScheduleCancelWindow(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                />
                            </Grid2>
                            <Grid2 item size={6}>
                                <Label>Dispatch Type<span style={{ color: 'red' }}>*</span></Label>
                                {/* <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                    placeholder="Dispatch Type" fullWidth variant="outlined" type="text" 
                                    value={dispatchType}
                                    onChange={(e) => setDispatchType(e.target.value)}
                                    InputProps={{
                                        inputProps: { min: 0 },
                                        style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                    }}
                                /> */}
                                <Select sx={{marginTop:'2%'}}
                                    value={dispatchType} fullWidth
                                    onChange={(e) => setDispatchType( e.target.value)}
                                    style={{ height: '50px', borderRadius: '8px', backgroundColor: '#FFFFFF'}}>
                                    
                                    {Object.entries(constants.dispatchTypeConst).map(([id, label]) => (
                                        <MenuItem key={id} value={id}>
                                            {label}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </Grid2>
                        </Grid2>

                        {dispatchType!=1 && (
                            <Grid2 item container sx={{marginTop:'24px'}} spacing={4} size={12}>
                                <Grid2 item size={6}>
                                    <Label>Delayed Time Threshold (0 - 180 minutes)<span style={{ color: 'red' }}>*</span></Label>
                                    <TextField  sx={{marginTop:'2%', color:'#1A1E25'}}
                                        placeholder="Delayed Time Threshold" fullWidth variant="outlined" type="text" 
                                        value={delayedTimeThreshold}
                                        // onChange={(e) => setDelayedTimeThreshold(e.target.value)}
                                        onChange={(e) => {
                                            const value = e.target.value;
                                            if (!isNaN(value) && Number(value) >= 0 && Number(value) <= 180) {
                                                setDelayedTimeThreshold(value);
                                            } else if (Number(value) > 180) {
                                                alert('You cannot enter a value greater than 180 minutes.');
                                            } else if (value === '') {
                                                setDelayedTimeThreshold('');
                                            }
                                        }}
                                        InputProps={{
                                            inputProps: { min: 0 },
                                            style: {height: '50px',fontSize: '16px',padding: '8px 14px',backgroundColor: '#FFFFFF'}
                                        }}
                                    />
                                </Grid2>
                            </Grid2>
                        )}

                        <Grid2 item sx={{marginTop:'24px', alignItems:'center', justifyContent:'center', display:'flex', marginBottom:'24px'}} size={12}>
                            
                                <Button onClick={saveData} variant="contained">Update</Button>
                            
                        </Grid2>
                    </Grid2>

                    <Snackbar open={snackbar} autoHideDuration={2000} onClose={handleSnackbarClose} message={message}></Snackbar>

                {/* </div>
            </div> */}
        </div>
    )
}

export default ScheduleRideSettings;